import React from "react";
import "./AuthShell.css";

function AuthShell({ eyebrow, title, lede, children, footer, width = 480 }) {
    return (
        <div className="auth-shell">
            <div className="auth-shell__grid" aria-hidden="true" />

            <header className="auth-shell__top">
                <div className="auth-shell__brand">
                    <span className="auth-shell__mark" aria-hidden="true">
                        <svg viewBox="0 0 16 16" width="14" height="14">
                            <rect
                                x="1"
                                y="1"
                                width="14"
                                height="14"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.25"
                            />
                            <rect x="4.5" y="4.5" width="7" height="7" fill="currentColor" />
                        </svg>
                    </span>
                    <span className="auth-shell__brand-name">PACKERAI</span>
                </div>
                <span className="auth-shell__build mono">v1.0 · BUILD 0481</span>
            </header>

            <main className="auth-shell__main">
                <div
                    className="auth-shell__panel"
                    style={{ "--auth-shell-width": `${width}px` }}
                >
                    {eyebrow && (
                        <div className="auth-shell__eyebrow uppercase-label">
                            {eyebrow}
                        </div>
                    )}
                    {title && <h1 className="auth-shell__title">{title}</h1>}
                    {lede && <p className="auth-shell__lede">{lede}</p>}
                    {children}
                    {footer && <div className="auth-shell__foot-row">{footer}</div>}
                </div>
            </main>

            <footer className="auth-shell__bottom">
                <span className="mono">ENGINEERED FOR FREIGHT</span>
                <span className="auth-shell__rule" aria-hidden="true" />
                <span className="mono">REACT · THREE.JS</span>
            </footer>
        </div>
    );
}

export default AuthShell;
